<template>
  <div>
    <WeSearchInput
      v-if="!product"
      class="mb-0"
      name="product"
      route="product"
      v-bind:placeholder="$t('searchProduct')"
      v-on:on-select="onSelect"
    />
    <WeCard class="bg-light" v-else>
      <div class="d-flex align-items-center">
        <!-- Product Image -->
        <img v-bind:src="product.image" class="mr-3" alt="" width="50" />
        <!-- ./Product Image -->

        <!-- Product Name -->
        <span class="font-weight-bold">{{ product.name }}</span>
        <!-- ./Product Name -->

        <div class="d-flex ml-auto">
          <!-- Apply -->
          <button class="btn btn-sm btn-outline-success" v-on:click="onSubmit">
            <i class="fas fa-check"></i> Seçimi Onayla
          </button>
          <!-- ./Apply -->

          <!-- Remove -->
          <button
            class="btn btn-sm btn-outline-danger ml-2"
            style="width: 35px"
            v-tooltip.bottom="'Seçimi Kaldır'"
            v-on:click="product = null"
          >
            <i class="fas fa-times"></i>
          </button>
          <!-- ./Remove -->
        </div>
      </div>
    </WeCard>
  </div>
</template>
<script>
const ProductImage = () => import("./components/ProductImage/Index.vue");
import { mapActions } from "vuex";
export default {
  name: "AddProduct",
  components: {
    ProductImage,
  },
  data() {
    return {
      submit: false,
      product: null,
    };
  },
  methods: {
    ...mapActions("priceAnalysis", ["createProduct"]),
    onSelect(data) {
      this.product = data;
    },
    onSubmit() {
      this.submit = true;
      this.createProduct({
        form: this.product,
        onFinish: () => {
          this.submit = false;
          this.product = null;
        },
        onError: () => {
          this.$toast.error("Ürün Eklenemedi");
        },
      });
    },
  },
};
</script>